import React from 'react';
import SkillsList from '../componentes/SkillsList';

const skills = [
    {
        title: 'Design the experience',
        list: [
            'UX/UI & interaction design',
            'Figma, Illustrator & Balsamiq',
            'User stories & personas',
            'Responsive design',
        ],
    },
    {
        title: 'Build the interface',
        list: [
            'JavaScript, React & Redux',
            'Vue.js & Vuex',
            'Semantic HTML & accessible CSS',
            'SCSS & responsive layouts',
        ],
    },
    {
        title: 'Connect the system',
        list: [
            'Python & FastAPI',
            'Node.js',
            'MySQL & PostgreSQL',
            'Full stack development',
        ],
    },
];

function AboutMe() {
    return (
        <section
            className="about-section"
            id="about"
            tabIndex="-1"
            aria-labelledby="about-title"
        >
            <div className="container section">
                <div className="about-grid">
                    <div>
                        <p className="eyebrow">
                            02 / A little about me
                        </p>
                        <h2 id="about-title">
                            A designer’s eye.
                            <br />
                            <em>
                                An engineer’s
                                <br className="desktop-break" />{' '}
                                mindset.
                            </em>
                        </h2>
                    </div>
                    <div className="about-copy">
                        <p className="about-lead">
                            I started in graphic design. Then I built
                            an internal tool and discovered I loved
                            making things work as much as making them
                            look right.
                        </p>
                        <p>
                            That curiosity became a career spanning
                            enterprise applications, websites, and
                            mobile tools. I work across UX, frontend,
                            and backend development, connecting the
                            details of an interface to the system
                            behind it.
                        </p>
                        <p>
                            My background in design and advertising
                            still shapes how I build: understand the
                            person, make the complex feel clear, and
                            care about the finish.
                        </p>
                        <p className="personal-note">
                            Away from the screen? Usually drawing,
                            making art, or building something out of
                            wood.
                        </p>
                        <a
                            className="text-link"
                            href="/data/Andrew-Kasper-Resume.pdf"
                            target="_blank"
                            rel="noreferrer"
                        >
                            The full story, on my résumé{' '}
                            <span aria-hidden="true">↗</span>
                            <span className="sr-only">
                                {' '}
                                (PDF, opens in a new tab)
                            </span>
                        </a>
                    </div>
                </div>
                <div className="skills-grid">
                    {skills.map((skill, index) => (
                        <SkillsList
                            key={skill.title}
                            skill={skill}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default AboutMe;
